module.exports = __webpack_public_path__ + "img/30.9f4361e9.png";